export const game: 'poe1' | 'poe2' = 'poe2';

export const poe1 = game as any === 'poe1';
export const poe2 = !poe1;

export const appName = poe1 ? 'PoE Filter' : 'PoE 2 Filter';
export const gameName = poe1 ? 'Path of Exile' : 'Path of Exile 2';
export const domainName = poe1 ? 'https://poe1filter.com' : 'https://poe2filter.com';
export const displayDomainName = poe1 ? 'poe1filter.com' : 'poe2filter.com';
export const abbrevGameName = poe1 ? 'PoE' : 'PoE2';

export const ACCOUNT_FILTER_DEFAULT_REALM = poe1 ? 'pc' : 'poe2';
export const FILTER_DESCRIPTION = poe1 ? 'Generated with poe1filter.com' : 'Generated with poe2filter.com';
export const SISTER_FILTER_DESCRIPTION = poe1 ? 'Generated with poe2filter.com' : 'Generated with poe1filter.com';
export const sisterDisplayDomainName = poe1 ? 'poe2filter.com' : 'poe1filter.com';
export const DEFAULT_FILTER_NAME = poe1 ? 'poe1filter' : 'poe2filter';

export const assetBaseUrl = location.hostname === 'localhost' ? '' : 'https://static.poe2filter.com';
export const apiBaseUrl = location.hostname === 'localhost' ? domainName : '';
export const imgPrefix = assetBaseUrl + (poe1 ? '/poe1' : '');
